import React, { useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { LiliTooltip, TooltipPosition } from '../LiliTooltip';

export interface LiliActionButtonProps {
  onClick?: () => void;
  ariaLabel: string;
  tooltip?: string;
  className?: string;
  testId?: string;
  children: React.ReactNode;
}

export const LiliActionButton = React.forwardRef<HTMLButtonElement, LiliActionButtonProps>(
  ({ onClick, ariaLabel, tooltip, className, testId, children }, ref) => {
    const tooltipId = useId();
    return (
      <>
        <button
          ref={ref}
          onClick={onClick}
          aria-label={ariaLabel}
          data-testid={testId}
          data-tooltip-id={tooltip ? tooltipId : undefined}
          className={twMerge(
            'flex items-center justify-center size-[30px] rounded-[2px] text-text-main-secondary hover:bg-surface-primary-bw-02',
            className
          )}>
          {children}
        </button>
        {tooltip && (
          <LiliTooltip targetId={tooltipId} description={tooltip} position={TooltipPosition.TOP} />
        )}
      </>
    );
  }
);
